import http from "./http";
import { apiURL } from "./apiendpoint";

export function sendMail(data) {
  return http.post(apiURL + "contact", data);
}
